import { render, staticRenderFns } from "./Torneo.vue?vue&type=template&id=1ca0169b&"
import script from "./Torneo.vue?vue&type=script&lang=js&"
export * from "./Torneo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports